import { CLICK_APPLY } from 'externals/_tracking/types/eventTypes.constants';
import { getMrphPageFormFactor } from 'helpers/metadataLogic.helpers';

export const HOME_INSURANCE_ID = '664582';
export const AUTO_INSURANCE_ID = '664581';
export const LIFE_INSURANCE_ID = '664583';

export const INSURANCE_VAR_2 = 'morpheus';

export function getQSAgeFilterRange(age) {
  var value = 18;
  if (age <= 24) {
    value = '22';
  } else if (age <= 34) {
    value = '30';
  } else if (age <= 44) {
    value = '40';
  } else if (age <= 54) {
    value = '50';
  } else if (age <= 64) {
    value = '60';
  } else {
    value = '85';
  }
  return value;
}

export function addInsuranceClickApplyListener(verticalName, eventHandler) {
  const el = document.getElementById('qsWidgetContainer');
  el.addEventListener(
    'click',
    function (e) {
      function walkToTop(el) {
        if (el.classList.contains('listing')) {
          return el;
        } else if (el.id === 'qsWidgetContainer') {
          return null;
        } else {
          return walkToTop(el.parentElement);
        }
      }
      const parent = walkToTop(e.target);
      if (parent === null) return null;
      const titles = parent.querySelector('.listing-title');
      if (titles) {
        eventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Page Form Factor': getMrphPageFormFactor(),
          Vertical: verticalName,
        });
      }
    },
    { passive: true },
  );
}

export const PLACEMENT = {
  offers: 'MORPHEUS_OFFERS',
  overview: 'MORPHEUS_OVERVIEW',
  public: 'MORPHEUS_PUBLIC_PAGE',
  actions: 'MY_ACTIONS',
};
